import { render, staticRenderFns } from "./ednCheck.vue?vue&type=template&id=ff23ec2c&"
import script from "./ednCheck.vue?vue&type=script&lang=js&"
export * from "./ednCheck.vue?vue&type=script&lang=js&"
import style0 from "./ednCheck.vue?vue&type=style&index=0&id=ff23ec2c&prod&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports